import type { GuideData } from "@/types/content";

type Section1EmpathyProps = {
  empathyText: string;
  guide: GuideData;
};

export function Section1Empathy({ empathyText, guide }: Section1EmpathyProps) {
  return (
    <section className="px-5 pb-9 pt-7">
      <p className="kicker mb-3.5">第一段 · 你的处境</p>
      <h2 className="font-serif text-[22px] font-medium leading-[1.45] tracking-tight text-ink-900">
        &ldquo;{empathyText}&rdquo;
      </h2>

      <div className="mt-7 rounded-[22px] border border-forest-200 bg-gradient-to-br from-forest-50 to-forest-100 px-5 py-[22px]">
        <p className="kicker mb-2.5 text-forest-700">这篇攻略不长</p>
        <p className="text-lg font-bold leading-snug tracking-tight text-forest-900">
          {guide.overviewText}
        </p>
        <p className="mt-3 text-[13px] leading-relaxed text-ink-600">
          看完大约3分钟。读到一半想直接问人,页面里随处可以叫管家。
        </p>
      </div>
    </section>
  );
}
